/* PARFUMPROBEN VERSAND – Warenkorb-Einschub, Variante 1c (gehört zu snippets/ppv-cart-delivery.liquid und
   snippets/ppv-cart-checkout.liquid, 03.11.2026).
   <ppv-cart-delivery> rechnet das voraussichtliche Lieferfenster im Browser (Europe/Berlin), so wie die Lieferzeit gemessen
   ist: min–max Werktage ab dem Tag nach der Bestellung (Mo–Fr, ohne Feiertage in NRW und ohne „Tage ohne Versand“). Mit
   Bestellschluss zählt eine spätere Bestellung wie eine vom nächsten Tag. Vom 23.11. bis zum letzten Bestelltag steht
   „Voraussichtlich vor Heiligabend“, solange das späteste Datum spätestens der 23.12. ist.
   <ppv-cart-express> setzt Shopifys Express-Knöpfe ein – nur PayPal und Apple Pay, erst wenn der Einschub aufgeht – und hält
   sie inaktiv, bis die Gratisprobe am Warenkorb steht. Express umgeht den Kassen-Knopf und damit dessen Abgleich in
   ppv-cart-rewards.js. */
(() => {
  if (window.__PPV_CART_CHECKOUT__) return;
  window.__PPV_CART_CHECKOUT__ = true;

  const DAY = 86400000;
  const WEEKDAYS = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  const MONTHS = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
  const XMAS_START = { month: 11, day: 23 };
  const XMAS_TARGET = { month: 12, day: 23 };

  /* Heute in Berlin als UTC-Mitternacht (so rechnet die Sommerzeit nicht mit) und die volle Stunde. */
  const berlinNow = () => {
    const parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date())
      .forEach(part => {
        parts[part.type] = Number(part.value);
      });
    return { day: Date.UTC(parts.year, parts.month - 1, parts.day), hour: parts.hour };
  };

  /* Ostersonntag nach der gaußschen Osterformel (gregorianisch). */
  const easter = year => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(year, month - 1, day);
  };

  /* Feiertage in NRW: die bundesweiten plus Fronleichnam und Allerheiligen. */
  const holidayCache = new Map();
  const holidays = year => {
    if (!holidayCache.has(year)) {
      const sunday = easter(year);
      const fixed = [[1, 1], [5, 1], [10, 3], [11, 1], [12, 25], [12, 26]].map(([month, day]) => Date.UTC(year, month - 1, day));
      const moving = [-2, 1, 39, 50, 60].map(offset => sunday + offset * DAY);
      holidayCache.set(year, new Set([...fixed, ...moving]));
    }
    return holidayCache.get(year);
  };

  /* Ein Tag „24.12.“, „24.12.26“ oder „24.12.2026“ → { day, month, year } (ohne Jahr: jedes Jahr). */
  const parseDay = text => {
    const match = String(text || '').trim().match(/^(\d{1,2})\.(\d{1,2})\.?(\d{2}|\d{4})?$/);
    if (!match) return null;
    const year = match[3] ? Number(match[3].length === 2 ? `20${match[3]}` : match[3]) : null;
    return { day: Number(match[1]), month: Number(match[2]), year };
  };

  /* Eine Spanne Tag für Tag, auch über Monats- und Jahresgrenzen („28.12.–4.1.“). Ohne Jahr gilt sie jedes Jahr; gerechnet
     wird dann in einem Schaltjahr, damit der 29.2. dabei ist. */
  const expandRange = (from, to) => {
    const dated = Boolean(from.year || to.year);
    /* Steht das Jahr nur am Ende („28.12.–4.1.27“), gehört der Anfang zum selben oder zum Vorjahr. */
    const wraps = from.month * 100 + from.day > to.month * 100 + to.day;
    const baseYear = from.year || (to.year ? to.year - (wraps ? 1 : 0) : 2024);
    const start = Date.UTC(baseYear, from.month - 1, from.day);
    let end = Date.UTC(to.year || baseYear, to.month - 1, to.day);
    if (end < start && !to.year) end = Date.UTC(baseYear + 1, to.month - 1, to.day);
    if (end < start || end - start > 366 * DAY) return [from];
    const days = [];
    for (let time = start; time <= end; time += DAY) {
      const date = new Date(time);
      days.push({ day: date.getUTCDate(), month: date.getUTCMonth() + 1, year: dated ? date.getUTCFullYear() : null });
    }
    return days;
  };

  /* „24.12., 31.12.2026“ oder Spannen „24.12.–26.12.“ → Liste einzelner Tage. */
  const parseDays = text =>
    String(text || '')
      .split(/[,;\n]+/)
      .flatMap(entry => {
        const [from, to] = entry.split(/\s*[–-]\s*/).map(parseDay);
        if (!from) return [];
        return to ? expandRange(from, to) : [from];
      });

  const isWorkday = (time, closed) => {
    const date = new Date(time);
    const weekday = date.getUTCDay();
    if (weekday === 0 || weekday === 6) return false;
    const year = date.getUTCFullYear();
    if (holidays(year).has(time)) return false;
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    return !closed.some(entry => entry.day === day && entry.month === month && (entry.year === null || entry.year === year));
  };

  /* Der n-te Werktag nach dem Tag `time`. */
  const addWorkdays = (time, count, closed) => {
    let result = time;
    for (let i = 0; i < count; i += 1) {
      do result += DAY;
      while (!isWorkday(result, closed));
    }
    return result;
  };

  const dayLabel = (time, withWeekday, withMonth) => {
    const date = new Date(time);
    const weekday = withWeekday ? `${WEEKDAYS[date.getUTCDay()]} ` : '';
    const month = withMonth ? ` ${MONTHS[date.getUTCMonth()]}` : '';
    return `${weekday}${date.getUTCDate()}.${month}`;
  };

  /* „Mi. 11.–Fr. 13. Nov.“; über den Monatswechsel und im Saisonhinweis ohne Wochentag: „30. Nov.–2. Dez.“ */
  const rangeLabel = (from, to, withWeekday) => {
    if (from === to) return dayLabel(to, withWeekday, true);
    const sameMonth = new Date(from).getUTCMonth() === new Date(to).getUTCMonth();
    const weekday = withWeekday && sameMonth;
    return `${dayLabel(from, weekday, !sameMonth)}–${dayLabel(to, weekday, true)}`;
  };

  class PPVCartDelivery extends HTMLElement {
    connectedCallback() {
      this.update();
    }

    update() {
      if (!this.hasAttribute('data-on')) return;
      const label = this.querySelector('.ppv-cd__label');
      const date = this.querySelector('.ppv-cd__date');
      if (!label || !date) return;
      try {
        const min = Math.max(1, Number(this.dataset.min) || 6);
        const max = Math.max(min, Number(this.dataset.max) || 8);
        const cutoff = Number(this.dataset.cutoff) || 24;
        const closed = parseDays(this.dataset.closed);
        const { day, hour } = berlinNow();
        const start = hour >= cutoff ? day + DAY : day;
        const from = addWorkdays(start, min, closed);
        const to = addWorkdays(start, max, closed);
        const year = new Date(day).getUTCFullYear();
        const last = parseDay(this.dataset.xmasLast);
        const xmas =
          Boolean(last) &&
          day >= Date.UTC(year, XMAS_START.month - 1, XMAS_START.day) &&
          day <= Date.UTC(last.year || year, last.month - 1, last.day) &&
          to <= Date.UTC(year, XMAS_TARGET.month - 1, XMAS_TARGET.day);
        const text = rangeLabel(from, to, !xmas);
        this.classList.toggle('ppv-cd--xmas', xmas);
        label.textContent = xmas ? 'Voraussichtlich vor Heiligabend' : 'Lieferung voraussichtlich';
        date.textContent = text;
        /* Wird es auf schmalen Handys eng (unter 8 px Luft oder zweite Zeile), ohne Wochentage schreiben. */
        const spare = this.clientWidth - label.offsetWidth - date.offsetWidth - 12;
        if (!xmas && this.clientWidth && (date.offsetTop > label.offsetTop || spare < 8)) date.textContent = rangeLabel(from, to, false);
      } catch (error) {
        /* Ohne Datum bleibt „Versand mit DHL“ stehen. */
      }
    }
  }

  const WALLETS = ['paypal', 'apple_pay']; /* nur diese, in dieser Reihenfolge */
  const SAMPLE_VARIANT = 'Gratisprobe-Variante';
  const WAIT_MAX = 2500; /* spätestens dann klickbar, auch wenn kein Vermerk kommt */

  /* Braucht dieser Warenkorb einen Gratisproben-Vermerk? Nur wenn Proben angeboten werden und der Mindestbestellwert erreicht ist. */
  const sampleNeeded = (total, count) => {
    const rewards = document.querySelector('ppv-cart-rewards');
    const state = window.__PPV_FREE_SAMPLE__;
    const offers = Boolean(state && state.offered && state.offered.size) || Boolean(rewards && rewards.querySelector('.ppv-free-sample__card'));
    const threshold = Number(rewards && rewards.dataset.sampleThreshold) || (state && state.threshold) || 3000;
    return offers && count > 0 && total >= threshold;
  };

  const drawerOpen = element => {
    const drawer = element.closest('cart-drawer');
    return !drawer || drawer.classList.contains('active');
  };

  class PPVCartExpress extends HTMLElement {
    connectedCallback() {
      /* Die Knöpfe (PayPal-SDK, Shopify-Wallets) laden erst, wenn der Einschub offen ist – nicht auf jeder Seite. */
      if (drawerOpen(this)) this.scheduleBuild();
      if (this.listening) return;
      this.listening = true;
      this.cart = {
        total_price: Number(this.dataset.total) || 0,
        item_count: Number(this.dataset.count) || 0,
        attributes: { [SAMPLE_VARIANT]: this.dataset.sample || '' }
      };
      this.onCart = event => this.check(event.detail);
      /* Andere Probe gewählt: bis der neue Vermerk gespeichert ist, nicht per Express bezahlen. */
      this.onPick = event => {
        const card = event.target instanceof Element && event.target.closest('.ppv-free-sample__card');
        if (!card || !card.dataset.variant) return;
        const note = this.cart.attributes && this.cart.attributes[SAMPLE_VARIANT];
        if (String(card.dataset.variant) !== String(note || '') && sampleNeeded(this.cart.total_price, this.cart.item_count)) this.hold();
      };
      document.addEventListener('ppv:cart', this.onCart);
      document.addEventListener('click', this.onPick, true);
      /* Erst nach dem Neuzeichnen prüfen – dann steckt der Gratisproben-Block wieder im Einschub. */
      setTimeout(() => this.check(this.cart), 0);
    }

    disconnectedCallback() {
      clearTimeout(this.buildTimer);
      this.listening = false;
      document.removeEventListener('ppv:cart', this.onCart);
      document.removeEventListener('click', this.onPick, true);
      clearTimeout(this.timer);
    }

    /* Nach „In den Warenkorb“ tauscht Dawn den Fuß kurz nacheinander zweimal aus (renderContents, onCartUpdate). Gebaut wird
       erst, wenn das Element eine Weile steht – sonst lädt PayPal doppelt. */
    scheduleBuild() {
      clearTimeout(this.buildTimer);
      this.buildTimer = setTimeout(() => {
        if (this.isConnected) this.build();
      }, 250);
    }

    /* Shopify liefert alle Express-Knöpfe als Vorlage. Vor dem Einsetzen bleiben nur PayPal und Apple Pay übrig – so baut
       Shopify die Reihe gleich mit zwei Knöpfen und ohne Lücken. */
    build() {
      const template = this.querySelector(':scope > template');
      if (!template) return;
      const content = template.content.cloneNode(true);
      const hosts = content.querySelectorAll('[wallet-configs]');
      let kept = hosts.length ? 0 : 1;
      hosts.forEach(host => {
        try {
          const configs = JSON.parse(host.getAttribute('wallet-configs'));
          const wanted = WALLETS.map(name => configs.find(config => config && config.name === name)).filter(Boolean);
          if (wanted.length) {
            host.setAttribute('wallet-configs', JSON.stringify(wanted));
            kept += 1;
          } else {
            host.remove();
          }
        } catch (error) {
          /* Unbekanntes Format: Shopify zeichnet alle Knöpfe, das CSS blendet die übrigen aus. */
          kept += 1;
        }
      });
      template.remove();
      if (!kept) {
        this.hidden = true;
        return;
      }
      this.append(content);
    }

    hold() {
      this.setAttribute('data-busy', '');
      this.inert = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.release(), WAIT_MAX);
    }

    release() {
      clearTimeout(this.timer);
      this.removeAttribute('data-busy');
      this.inert = false;
    }

    check(cart) {
      if (!cart) return;
      this.cart = cart;
      const note = cart.attributes && cart.attributes[SAMPLE_VARIANT];
      if (note || !sampleNeeded(Number(cart.total_price) || 0, Number(cart.item_count) || 0)) this.release();
      else this.hold();
    }
  }

  if (!customElements.get('ppv-cart-delivery')) customElements.define('ppv-cart-delivery', PPVCartDelivery);
  if (!customElements.get('ppv-cart-express')) customElements.define('ppv-cart-express', PPVCartExpress);

  const drawer = document.querySelector('cart-drawer');
  /* Dawn und der Größen-Wähler sperren die Liste, solange eine Änderung läuft: so lange auch Express sperren. */
  const holdWhileBusy = list => {
    const busy = list.classList.contains('cart__items--disabled');
    drawer.querySelectorAll('ppv-cart-express').forEach(element => (busy ? element.hold() : element.check(element.cart)));
  };
  if (drawer) {
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        const target = mutation.target;
        /* Einschub geht auf: Express-Knöpfe bauen, Lieferfenster frisch rechnen (die Seite kann lange offen gestanden haben). */
        if (target === drawer) {
          if (!drawer.classList.contains('active')) return;
          drawer.querySelectorAll('ppv-cart-express').forEach(element => element.scheduleBuild());
          drawer.querySelectorAll('ppv-cart-delivery').forEach(element => element.update());
          return;
        }
        if (target.id === 'CartDrawer-CartItems') holdWhileBusy(target);
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], subtree: true });
    /* Auf der Warenkorb-Seite sperrt Dawn bei jeder Änderung die Liste der Seite statt der im Einschub. */
    const pageList = document.getElementById('main-cart-items');
    if (pageList) new MutationObserver(() => holdWhileBusy(pageList)).observe(pageList, { attributes: true, attributeFilter: ['class'] });
  }

  /* Fokus-Wächter hinter den Express-Knöpfen: Tab aus PayPal (fremdes iframe) oder Apple Pay (Shadow DOM) bleibt im Einschub.
     Kommt der Fokus per Umschalt+Tab vom ersten Element (Dawns Fokusfalle), geht er zurück auf „Zur Kasse“. */
  document.addEventListener('focusin', event => {
    const guard = event.target;
    if (!(guard instanceof Element) || !guard.classList.contains('ppv-co__end')) return;
    const inner = guard.closest('.drawer__inner');
    if (!inner) return;
    const close = inner.querySelector('.drawer__close');
    const target = event.relatedTarget && event.relatedTarget === close ? inner.querySelector('#CartDrawer-Checkout') : close;
    if (target) target.focus();
  });
})();
